export const AppbarTopic = { fontSize: '1.5rem', fontFamily: "'YekanBold !important'" }
export const ModalTopic = { fontSize: '1.5rem', fontFamily: "'YekanBold !important'", width: "100%", justifyContent: "center" }
